/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Shortage_Warning_Col_NeededInputs */

const vi_packaging_shortage_warning_col_needed = /** @type {(inputs: Packaging_Shortage_Warning_Col_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cần`)
};

/**

* @param {Packaging_Shortage_Warning_Col_NeededInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_shortage_warning_col_needed = /** @type {((inputs?: Packaging_Shortage_Warning_Col_NeededInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Shortage_Warning_Col_NeededInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_shortage_warning_col_needed(inputs)
});